import { API_BASE_URL } from "../../commons";

export const CURRENT_USER_API = `${API_BASE_URL}/users/current`;
